import { IS_MEZO_MAINNET } from "#/shared/constants"
import {
  MarketHeader,
  MarketItemList,
  MarketMatsnetFooter,
  MarketSurvey,
} from "#/ui/Market"

export default function MarketPage() {
  return (
    <>
      <MarketHeader />
      <MarketItemList />
      <MarketSurvey />
      {!IS_MEZO_MAINNET && <MarketMatsnetFooter />}
    </>
  )
}
